import store from "@/store"

export function isAliveToken (success = () => {}, error = () => {}) {
  if (store.getters['auth/isCheckExpired']()) {
    store.dispatch('auth/CHECK_TOKEN_ALIVE').then(
      () => {
        success()
      }
    ).catch(error)
  } else {
    success()
  }
}
